module.exports = __webpack_public_path__ + "img/mockup-move-apps-EN.0cd4d605.png";